import React, { useCallback, useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import Icon from 'react-icons-kit'
import { chevronLeft } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
// import { dateFormate } from '../../../../utils/helpers'

import LoadingComponent from '../../../../components/loading/Index'

const Show = () => {
    const { id } = useParams()
    const [isLoading, setLoading] = useState(true)
    const [item, setItem] = useState(null)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
    const fetchData = useCallback(async () => {
        const data = await Requests.MarriageCounseling.Show(id, header)
        if (data) {
            setItem(data)
            setLoading(false)
        }
        setLoading(false)
    }, [id, header])


    useEffect(() => {
        fetchData()
    }, [id, header, fetchData])


    if (isLoading) return <LoadingComponent />

    return (
        <div className="marriage-story pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Show Marriage Counselling</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/marriage-counselling"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">

                                <table className="table table-md table-borderless">
                                    <tbody>
                                        <tr>
                                            <td>header_image</td>
                                            <td>{item.header_image ?
                                                <img src={item.header_image} className="img-fluid" alt="..." />
                                                : 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>header_title</td>
                                            <td>{item.header_title || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>header_descripton</td>
                                            <td>{item.header_descripton || 'N/A'}</td>
                                        </tr>

                                        <tr>
                                            <td>how_does_part_1</td>
                                            <td>{item.how_does_part_1 || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>how_does_part_2</td>
                                            <td>{item.how_does_part_2 || 'N/A'}</td>
                                        </tr>

                                        <tr>
                                            <td>counselor_1_image</td>
                                            <td>{item.counselor_1_image ?
                                                <img src={item.counselor_1_image} className="img-fluid" alt="..." />
                                                : 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_1_name</td>
                                            <td>{item.counselor_1_name || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_1_sort_into</td>
                                            <td>{item.counselor_1_sort_into || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_1_description</td>
                                            <td>{item.counselor_1_description || 'N/A'}</td>
                                        </tr>

                                        <tr>
                                            <td>counselor_2_image</td>
                                            <td>{item.counselor_2_image ?
                                                <img src={item.counselor_2_image} className="img-fluid" alt="..." />
                                                : 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_2_name</td>
                                            <td>{item.counselor_2_name || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_2_sort_into</td>
                                            <td>{item.counselor_2_sort_into || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_2_description</td>
                                            <td>{item.counselor_2_description || 'N/A'}</td>
                                        </tr>
                                        
                                        <tr>
                                            <td>counselor_3_image</td>
                                            <td>{item.counselor_3_image ?
                                                <img src={item.counselor_3_image} className="img-fluid" alt="..." />
                                                : 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_3_name</td>
                                            <td>{item.counselor_3_name || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_3_sort_into</td>
                                            <td>{item.counselor_3_sort_into || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>counselor_3_description</td>
                                            <td>{item.counselor_3_description || 'N/A'}</td>
                                        </tr>

                                        <tr>
                                            <td>book_now_text</td>
                                            <td>{item.book_now_text || 'N/A'}</td>
                                        </tr>

                                    </tbody>
                                </table>


                                <br />

                                {item.admin ?
                                    <div className="text-end">
                                        <h6><i>Created by</i></h6>
                                        <p className="mb-0">{item.admin.name}</p>
                                        <p className="mb-0">{item.admin.email}</p>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Show;